import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import { CopyIconDouble } from '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import { formatNumberShortFloor } from '../../../../utils/convertXp.js';
import styles from './index.module.scss.js';
import { RewardIconWrapper } from '../RewardIconWrapper/index.js';
import { RewardIcon } from '../RewardIcon/index.js';

const ProfileCard = ({
  nextRevard,
  text = {
    nextLevel: "Next level",
    copy: "Copied!"
  },
  className,
  id,
  level,
  reward,
  name,
  onClickCopyUserId,
  ...props
}) => {
  const [copyTimer, setCopyTimer] = useState(0);
  const [isStartAnimationCopy, setStartAnimationCopy] = useState(true);
  useEffect(() => {
    let interval;
    if (copyTimer > 0) {
      interval = setInterval(() => {
        setCopyTimer((prev) => prev - 1);
      }, 1e3);
    }
    return () => clearInterval(interval);
  }, [copyTimer]);
  const handleCopyIdUser = () => {
    if (copyTimer === 0) {
      setStartAnimationCopy(true);
      setTimeout(() => {
        setStartAnimationCopy(false);
      }, 500);
      if (onClickCopyUserId) {
        onClickCopyUserId(id);
      }
      setCopyTimer(3);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { ...props, className: cx(styles.box, className) }, /* @__PURE__ */ React.createElement("div", { className: styles.row }, /* @__PURE__ */ React.createElement("div", { className: styles.header }, /* @__PURE__ */ React.createElement("div", null, level ? /* @__PURE__ */ React.createElement(
    RewardIconWrapper,
    {
      icon: String(level),
      className: styles["header-icon"]
    },
    /* @__PURE__ */ React.createElement(RewardIcon, { icon: String(level) })
  ) : null), /* @__PURE__ */ React.createElement("div", { className: styles["header-box-right"] }, /* @__PURE__ */ React.createElement("div", { className: styles["header-title"] }, name), /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: handleCopyIdUser,
      className: cx(styles["header-description"], {
        [styles.disabled]: copyTimer !== 0
      })
    },
    /* @__PURE__ */ React.createElement("div", null, "ID: ", id),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles["header-copy-container"], {
          [styles["fade-out"]]: copyTimer !== 0 && isStartAnimationCopy,
          [styles["fade-in"]]: copyTimer !== 0 && !isStartAnimationCopy
        })
      },
      isStartAnimationCopy === false && copyTimer !== 0 ? /* @__PURE__ */ React.createElement("div", { className: styles.label }, text.copy) : /* @__PURE__ */ React.createElement(CopyIconDouble, { className: cx(styles["header-copy"]) })
    )
  )))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: cx(styles.bar, "bar") }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles["bar-filled"]),
      style: {
        width: reward?.xp?.current != null && reward?.xp?.max != null && Number(reward.xp.max) !== 0 ? `${Number(reward.xp.current) / Number(reward.xp.max) * 100}%` : "0%"
      }
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: styles.row }, /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.xp }, formatNumberShortFloor(Number(reward.xp.current)), " XP", /* @__PURE__ */ React.createElement("div", { className: styles["xp-active"] }, "/", formatNumberShortFloor(Number(reward.xp.max)), " XP"))), /* @__PURE__ */ React.createElement("div", { className: styles.divider }), /* @__PURE__ */ React.createElement("div", { className: styles["next-level"] }, /* @__PURE__ */ React.createElement("div", { className: styles["next-level-prev"] }, text.nextLevel, ":"), /* @__PURE__ */ React.createElement("div", { className: styles["next-level-active"] }, nextRevard.icon ? /* @__PURE__ */ React.createElement(
    RewardIconWrapper,
    {
      icon: String(nextRevard.icon),
      className: styles["level-icon"]
    },
    /* @__PURE__ */ React.createElement(RewardIcon, { icon: nextRevard.icon })
  ) : null, /* @__PURE__ */ React.createElement("div", null, nextRevard.name))))));
};
ProfileCard.displayName = "ProfileCard";

export { ProfileCard };
//# sourceMappingURL=index.js.map
